import { render } from "./MoveableTappableSelector.vue?vue&type=template&id=87f00250&scoped=true"
import script from "./MoveableTappableSelector.vue?vue&type=script&lang=ts"
export * from "./MoveableTappableSelector.vue?vue&type=script&lang=ts"

import "./MoveableTappableSelector.vue?vue&type=style&index=0&id=87f00250&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-87f00250"

export default script